function linear (t) {
  return t;
}

export { linear as default };
